import React from 'react';
import { FDEmphasisSurface, FDHeadlineText, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

const InvestingDetailsChart = ({ resource, isLastChart }) => {
  const theme = useTheme();
  return (
    <FDStack direction={'column'} spacing={6}>
      <FDStack direction={'column'} spacing={3}>
        <Richtext richtext Component={FDHeadlineText} size={'sm'} align={'center'} value={resource.attr('title')} />
        <div style={{ width: '100%', aspectRatio: resource.relationship(fr.relationships.image.name)?.meta('aspectRatio') }}>
          <FDEmphasisSurface>
            <ImageRel relationship={resource.relationship(fr.relationships.image.name)} fullScreenExpansionIconColor="white" />
          </FDEmphasisSurface>
        </div>
      </FDStack>
      { isLastChart ? null : <hr
        style={{
          border: 'none', height: '1px', margin: `${theme.spacing(2)}px auto`, backgroundColor: `${theme.palette.facet.lightGray2}`, width: '120px',
        }}
      />}
    </FDStack>
  );
};

export default InvestingDetailsChart;
